import TopBar from "component/ui/TopBar";
import styles from "../../Create/Create.css";
import {options} from "component/const/ForShort";
import {useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import SubmitButton from "./component/SubmitButton";
import axios from "axios";
import {restUrl} from "../../../../apiUrl";
import {AboutPre, partition} from "../component/AboutPre";

export default function PreShort(){
    const [answers, setAnswer] = useState([]);
    const setAnswers = (value) => {
        console.log('setAnswers', value)
        setAnswer(value)
    }
    const {state} = useLocation();
    const [problems, setProblems] = useState([]);
    
    useEffect(() => {
        setProblems(mockup)
    }, []);
    
    useEffect(() => {
        console.log('problems',problems);
        if (problems.length > 0) {
            console.log('setAnswer')
            setAnswers(problems.map(problem => ({ problem_id: problem.id, application_id: state.appId, response: "" })));
        }

        axios.get(`${restUrl}/activity_test_application?id=eq.${state.appId}`)
            .then((res) => res.data[0].preview_response.length>0 ?
                setAnswers(res.data[0].preview_response.split(partition))
                :setAnswers(problems.map(_ => '')))
            console.log('setAnswer')
    }, [problems]);

    useEffect(() => {
        console.log('answers',answers)
    },[answers])
    
    const onChange = (value, index) => {
        const updatedAnswers = [...answers];
        updatedAnswers[index]?console.log('true'):console.log('false')
        if (updatedAnswers.length > index) {
            updatedAnswers[index] = value;
            console.log('setAnswer')
            setAnswers(updatedAnswers);
        }
    };
    
    return (
        <>
            <AboutPre testId={state.testId} />
            <TopBar title="출제 내용" />
            {problems?.map((it, index) => (
                <section key={it.type + index.toString()} className={"problemSection"}>
                    <div className="problemContainer borderRight !p-2">
                        <div style={{ display: "flex" }}>
                            <span style={styles.index}>{String(index + 1).padStart(2, "0").padEnd(3, ".") + it.problem}</span>
                        </div>
                        {it.selections?.map((i, ind) => (i !== "" ?
                                <div key={String(index).padStart(2, "0").padEnd(3, ".") + ind.toString()} style={{ marginLeft: "20px", display: "flex" }}>
                                    <span style={styles.index}>{[options[0].key, options[3].key, options[4].key].includes(it.type) && (ind + 1) + ". " + i}</span>
                                </div> : null
                        ))}
                    </div>
                    <div className="infoContainer p-2">
                        {[options[0].key, options[1].key, options[2].key].includes(it.type) && <>
                            <div>
                                <span>난이도:</span>
                                <span style={{ fontWeight: "bold" }}>{it.difficulty}</span>
                            </div>
                            <div>
                                <span>점수:</span>
                                <span style={{ fontWeight: "bold" }}>{it.score}</span>
                            </div>
                        </>}
                        {[options[0].key, options[1].key, options[3].key, options[4].key].includes(it.type) && <div className="DSContainer">
                            <fieldset>
                                {it.selections?.map((i, ind) => (<label key={i + ind.toString()}>
                                    <input
                                        className={"inputBorder"}
                                        type="radio" checked={answers[index] === i}
                                           onChange={() => onChange(i, index)} />
                                    {i}
                                </label>))}
                            </fieldset>
                        </div>}
                        {it.type === options[2].key && <>
                            <span>오타 {it.allowTypo ? "허용" : "조심"}</span>
                            <span>띄어쓰기 {it.allowSpacingTypo ? "상관 없음" : "조심"}</span>
                            <input value={answers[index] || ""}
                                   placeholder={"입력하세요"}
                                   className={"inputBorder inputTextAreaMargin"}
                                   onChange={(e) => onChange(e.target.value, index)}/>
                        </>}
                    </div>
                </section>
            ))}
            <div className="saveContainer">
                <SubmitButton answers={answers} appId={state.appId}/>
            </div>
        </>
    );
}

const mockup = [
    {
        "id": 197,
        "problem": "시험을 응시하시겠습니까?",
        "score": 0,
        "difficulty": "미정",
        "type": "ox",
        "category": "단답형",
        "selections": ["O", "X"],
        "test_id": 130
    },
    {
        "id": 196,
        "problem": "현재 몇년입니까?",
        "score": 0,
        "difficulty": "미정",
        "type": "mulCho",
        "category": "단답형",
        "selections": ["2025", "2026", "2027", "2028"],
        "test_id": 130
    },
    {
        "id": 198,
        "problem": "본인의 성함이 어떻게 되십니까?",
        "score": 0,
        "difficulty": "미정",
        "type": "short",
        "category": "단답형",
        "selections": null,
        "test_id": 130
    }]